import styles from './SelectedProviderChip.module.css';

interface Props {
  name: string;
  onRemove: () => void;
}

export const SelectedProviderChip = ({ name, onRemove }: Props) => {
  return (
    <span className={styles.chip}>
      <span className={styles.name}>{name}</span>
      <button
        type="button"
        className={styles.removeBtn}
        onClick={onRemove}
        aria-label={`Remove ${name}`}
      >
        &times;
      </button>
    </span>
  );
};
